import React from 'react';
import '../styles/components/categoryBreadCrumbs.scss';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Breadcrumbs, Container, Typography } from '@mui/material';

const categoryBreadCrumbs = ({ breadcrumbs, title, subTitle }) => {
    return (
            <section className='category-header' >
                <Container maxWidth="xl">
                    {title && subTitle ?
                        <div className='category_title'>
                            <Typography variant='h4'>{title}</Typography>
                            <Typography variant='h6'>{subTitle}</Typography>
                        </div> : null}
                    <div className='breadcrums'>
                        <Breadcrumbs
                            separator={<NavigateNextIcon fontSize="small" />}
                            aria-label="breadcrumb"
                        >
                            {breadcrumbs}
                        </Breadcrumbs>
                    </div>
                </Container>
            </section>
    )
}

export default categoryBreadCrumbs